import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { SWAlertService } from '../../services/swalert.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {
  ChangePasswordForm: FormGroup;//สร้างกลุ่ม Object Data
  get f() { return this.ChangePasswordForm.controls; }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private System: TSFuntionService,
    private http: HttpClient,
    private Swal: SWAlertService
  ) { }

  submitted = false;
  _fieldTextType1: boolean = false;
  _fieldTextType2: boolean = false;
  _inputType1: string;
  _inputType2: string;
  IsPattern: boolean = false;
  IsMatch: boolean = false;
  MsgPattern = "";
  MsgMatch = "";


  ngOnInit() {
    this._inputType1 = 'password';
    this._inputType2 = 'password';
    this.System.OnFocus("txtUserId", "btnSubmit");
    this.System.OnFocus("txtOldPassword", "btnSubmit");
    this.System.OnFocus("txtNewPassword", "btnSubmit");
    this.System.OnFocus("txtConfirmPassword", "btnSubmit");
    this.ChangePasswordForm = this.formBuilder.group({
      sUserName: ["", [Validators.required]],
      sOldPassword: ["", [Validators.required]],
      sNewPassword: ["", [Validators.required,
      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{6,12}$')]],
      sConfirmPassword: ["", [Validators.required]]
    }, {
      validator: this.MustMatch('sNewPassword', 'sConfirmPassword')
    });
  }

  //#region Validate
  isFieldValid(field: string) {
    return !this.ChangePasswordForm.get(field).valid && this.ChangePasswordForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  //#endregion

  //#region Button Submit
  onSubmit() {
    this.System.BlockUI();
    let _this = this;
    if (this.ChangePasswordForm.invalid) {
      this.System.UnBlockUI();
      this.validateAllFormFields(this.ChangePasswordForm);
      return;
    } else {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
      let formObj = this.ChangePasswordForm.getRawValue();
      let ITEM = JSON.stringify(formObj);
      this.http.post<any>(this.System.SiteName + "api/_System/_ChangePassword", formObj, httpOptions).subscribe(res => {
      //this.http.post<any>(this.System.SiteName + "api/_System/_ChangePassword", ITEM, { headers }).subscribe(res => {
        this.System.UnBlockUI();
        if (res.Status == this.System.SysProcess.Success) {
          this.Swal.SwAlert.Success(this.Swal.BoxMsg.Title_Success, this.Swal.BoxMsg.Desc_Success_Sent_Email_Change_PWD, function () {
            _this.router.navigate(["/login"]);
          });
        } else {
          this.Swal.SwAlert.Error(this.Swal.BoxMsg.Title_Warning, res.Msg, function () { Swal.close(); });

          //this.ChangePasswordForm.get("sUserName").markAsUntouched({ onlySelf: true });
          //this.ChangePasswordForm.get("sOldPassword").markAsUntouched({ onlySelf: true });
          //this.ChangePasswordForm.get("sNewPassword").markAsUntouched({ onlySelf: true });
          //this.ChangePasswordForm.get("sConfirmPassword").markAsUntouched({ onlySelf: true });

          //this.ChangePasswordForm.controls.sUserName.setValue(null);
          //this.ChangePasswordForm.controls.sOldPassword.setValue(null);
          //this.ChangePasswordForm.controls.sNewPassword.setValue(null);
          //this.ChangePasswordForm.controls.sConfirmPassword.setValue(null);

          //this.ChangePasswordForm.controls["sUserName"].setValidators(Validators.required);//กำหนด Validate
          //this.ChangePasswordForm.controls["sOldPassword"].setValidators(Validators.required);//กำหนด Validate
          //this.ChangePasswordForm.controls["sNewPassword"].setValidators(Validators.required);//กำหนด Validate
          //this.ChangePasswordForm.controls["sConfirmPassword"].setValidators(Validators.required);//กำหนด Validate

          //this.ChangePasswordForm.controls["sUserName"].setErrors(null);//ปรับ Control ให้เป็นปกติ
          //this.ChangePasswordForm.controls["sOldPassword"].setErrors(null);//ปรับ Control ให้เป็นปกติ
          //this.ChangePasswordForm.controls["sNewPassword"].setErrors(null);//ปรับ Control ให้เป็นปกติ
          //this.ChangePasswordForm.controls["sConfirmPassword"].setErrors(null);//ปรับ Control ให้เป็นปกติ

          //this.ChangePasswordForm.controls["sUserName"].updateValueAndValidity();//Update Validate
          //this.ChangePasswordForm.controls["sOldPassword"].updateValueAndValidity();//Update Validate
          //this.ChangePasswordForm.controls["sNewPassword"].updateValueAndValidity();//Update Validate
          //this.ChangePasswordForm.controls["sConfirmPassword"].updateValueAndValidity();//Update Validate
        }
      });
    }
  }
  //#endregion

  //#region Button Back
  Back() {
    this.router.navigate(["/login"]);
  }
  //#endregion

  //#region MustMatch Password
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }
  //#endregion

  //#region NewPassword : Click Icon Eye
  toggleFieldTextType_NewPassword() {
    this._fieldTextType1 = !this._fieldTextType1;
    if (this._fieldTextType1) {
      this._inputType1 = 'text';

    } else {
      this._inputType1 = 'password';
    }
  }
  //#endregion

  //#region ConfirmPassword : Click Icon Eye
  toggleFieldTextType_ConfirmPassword() {
    this._fieldTextType2 = !this._fieldTextType2;
    if (this._fieldTextType2) {
      this._inputType2 = 'text';

    } else {
      this._inputType2 = 'password';
    }
  }
  //#endregion

  //#region Check Pattern Password
  CheckPatternPassword(_Item) {
    //let _password = _Item.target.value;
    if (this.ChangePasswordForm.controls.sNewPassword.invalid) { //check validate

      this.IsPattern = true;

      if (this.ChangePasswordForm.controls.sNewPassword.errors.pattern) { //check error pattern case
        this.MsgPattern = "The password pattern wrong";
      }
      else {
        this.MsgPattern = "Please inform your new password";
      }
    } else {
      this.IsPattern = false;
    }
  }
  //#endregion

  //#region Check Match Password
  CheckMatchPassword(_Item) {
    if (this.ChangePasswordForm.controls.sConfirmPassword.invalid) { //check validate

      this.ChangePasswordForm.controls.sConfirmPassword.markAsTouched({ onlySelf: true });

      if (this.ChangePasswordForm.controls.sConfirmPassword.errors.mustMatch) { //check error match case

        let sNewPassword = this.ChangePasswordForm.value['sNewPassword'];
        let sConfirmPassword = this.ChangePasswordForm.value['sConfirmPassword'];
        this.IsMatch = true;

        if (sNewPassword == sConfirmPassword || sConfirmPassword == "") { //check password 2 field
          this.MsgMatch = "Please inform your new password";
        }
        else {
          this.MsgMatch = "The password not match";
        }
      }
    } else {
      this.IsMatch = false;
    }
  }
  //#endregion
}
